module.exports = __webpack_public_path__ + "img/lastcardB.9efb5519.png";